module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAMCAYAAABm+U3GAAAA/0lEQVQ4T6XST07CQBgF8PemsrNqOACJC7cK6R+2mHgCVp5OV2yMJyibrtsIcgFNlB0bDtCZjwwBU+m0JTDLSeaX9833OAuCN5B3nlLjhyz7xhlnEQRDDbxSqRfOwnAuIn0APxeeNzoVt2hBJhC5AjDhIo5vC61TAL1T8c8wjLVIAuAawIfy/Sfayc/BXeggTddb2IV3lHq8z/Ovpi+vQ+2bP7iCk78dclSHz6MoMsZMy+PbpPsg/+Bj8Ta0ktj5LQfJLSrGJALc7BdVTlqbuAkvyC60nrahtYldOMklRC6PQVthR1vs1banrvHLDaosz1WvXc/fAayU7z+3odbYALV+r/An7L2bAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/comment/s-resize.png
// module id = FxPF
// module chunks = 1